module.exports = __webpack_public_path__ + "assets/img/no_img_a.6547cbf6.png";